// import school from '../MapIcons/school.svg'
// import ylwsjg from './ylwsjg.svg'
// import ggwhcs from './ggwhcs.svg'
// import lyjq from './lyjq.svg'
// import zjhdcs from './zjhdcs.svg'
// import dxcs from './dxcs.svg'
// import zsfwjg from './zsfwjg.svg'
// import hgyq from './hgyq.svg'
// import qyjcxx from './qyjcxx.svg'
// import jyjq from './jyjq.svg'
// import mk from './mk.svg'
// import imgDaily from './map/icon_daily.svg'
// import imgTrouble from './map/icon_trouble.svg'
// import imgQuestion from './map/icon_question.svg'
// import imgAlleys from './map/icon_alleys.svg'
// import imgBackStreet from './map/icon_back_street.svg'
// import imgFirst from './map/icon_first.svg'
// import imgProperty from './map/icon_property.svg'
// import imgCamera from './map/icon_camera.svg'
// import imgSand from './map/ico_sand.svg'
// import imgSandWarning from './map/ico_sand_warning.svg'
// import imgLampblack from './map/ico_lampblack.svg'
// import imgLampblackWarning from './map/ico_lampblack_warning.svg'
// import imgSmall from './map/ico_small.svg'
// import imgSmallWarning from './map/ico_small_warning.svg'
// import imgControl from './map/img_control.svg'
// import imgControlWarning from './map/img_control_warning.svg'
// import imgStreet from './map/img_street.svg'
// import imgStreetWarning from './map/img_street_warning.svg'
// import imgSiteStaff from './map/img_site_staff.svg'
// import imgSiteStaffWarning from './map/img_site_staff_warning.svg'
// import imgSandStaff from './map/img_sand_staff.svg'
// import imgSandStaffWarning from './map/img_sand_staff_warning.svg'
// import imgCommunity from './map/img_community.svg'
// import imgCommunityWarning from './map/img_community_warning.svg'
// import imgReport from './map/img_report.svg'
// import imgReportRed from './map/img_report_warning.svg'
// import imgReportYellow from './map/img_report_yellow.svg'
// import imgAuto from './map/img_auto.svg'
// import imgAutoRed from './map/img_auto_red.svg'
// import imgAutoOrange from './map/img_auto_orange.svg'
// import imgAutoBlue from './map/img_auto_blue.svg'
// import imgInspector from './map/img_inspector.svg'
// import imgInspectorWarning from './map/img_inspector_warning.svg'
// import img12345 from './map/ico_12345.svg'
// import img12345Warning from './map/ico_12345_warning.svg'
// import icoUserOnline from './map/ico_user_online.svg'
// import icoUserOnlineSelect from './map/ico_user_online_select.svg'
// import imgSmallSand from './map/img_small_sand.svg'
// import imgSmallSandWarning from './map/img_small_sand_warning.svg'
// export default {
//   daily: imgDaily, // 日常检查
//   trouble: imgTrouble, // 市级检查突出问题
//   question: imgQuestion, // 疑难点位问题
//   alleys: imgAlleys, // 街巷巡查
//   backStreet: imgBackStreet, // 背街小巷
//   first: imgFirst, // 首环办检查事件
//   proerty: imgProperty, // 物业巡查
//   camera: imgCamera, //摄像头
//   'h5-small': imgSmall, // 微站
//   'h5-small-warning': imgSmallWarning,

//   'h5-control': imgControl, // 国控站
//   'h5-control-warning': imgControlWarning, // 国控站

//   'h5-street': imgStreet, // 街道站
//   'h5-street-warning': imgStreetWarning, // 街道站

//   'h5-siteStaff': imgSiteStaff, // 子站责任人
//   'h5-siteStaff-warning': imgSiteStaffWarning, // 子站责任人

//   'h5-sandStaff': imgSandStaff, // 扬尘巡检人员
//   'h5-sandStaff-warning': imgSandStaffWarning, // 扬尘巡检人员

//   'h5-lampblack': imgLampblack, // 油烟
//   'h5-lampblack-warning': imgLampblackWarning,

//   'h5-community': imgCommunity, // 社区站
//   'h5-community-warning': imgCommunityWarning, // 社区站

//   'h5-sand': imgSand, // 沙尘
//   'h5-sand-warning': imgSandWarning,

//   'h5-report': imgReport, // 子站上报案件
//   'h5-report-red': imgReportRed, // 子站上报案件
//   'h5-report-yellow': imgReportYellow, // 子站上报案件

//   'h5-auto': imgAuto, // 自动报警
//   'h5-auto-red': imgAutoRed, // 子站自动报警
//   'h5-auto-orange': imgAutoOrange, // 子站自动报警
//   'h5-auto-blue': imgAutoBlue, // 子站自动报警

//   'h5-inspection': imgInspector, // 巡检上报案件
//   'h5-inspection-warning': imgInspectorWarning, // 巡检上报案件

//   'h5-12345': img12345,
//   'h5-12345-warning': img12345Warning,
//   icoUserOnline: icoUserOnline,
//   icoUserOnlineSelect: icoUserOnlineSelect,
//   'h5-smallsand': imgSmallSand, // 巡检上报案件
//   'h5-smallsand-warning': imgSmallSandWarning, // 巡检上报案件
//   567: school, // 学校
//   581: ylwsjg, // 医疗卫生机构
//   570: ggwhcs, // 公共文化场所
//   577: lyjq, // 旅游景区
//   579: zjhdcs, // 宗教活动场所
//   582: dxcs, // 大型超市
//   568: zsfwjg, // 住宿服务机构
//   572: hgyq, // 化工园区
//   574: qyjcxx, // 企业基础信息
//   571: jyjq, // 加油加气
//   576: mk, // 煤矿
// }
import SchoolIcon from './school-t.svg'
import SchoolIcon2 from './school-t2'
import MedicalCare from './ylwsjg'
import Culture from './ggwhcs'
import Travel from './lyjq'
import Religion from './zjhdcs'
import Supermarket from './dxcs'
import Accommodation from './zsfwjg'
import ChemicalIndustry from './hgyq'
import Enterprise from './qyjcxx'
import GasStation from './jyjq'
import CoalMine from './mk'

export {
  SchoolIcon,
  SchoolIcon2,
  MedicalCare,
  Culture,
  Travel,
  Religion,
  Supermarket,
  Accommodation,
  ChemicalIndustry,
  Enterprise,
  GasStation,
  CoalMine,
}
